import { render, staticRenderFns } from "./MST_BASE.vue?vue&type=template&id=270ecabe"
import script from "./MST_BASE.vue?vue&type=script&lang=ts"
export * from "./MST_BASE.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports